import React, { useState, useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import AuthService, { forgotPassword } from "../../services/api/AuthService";
import {
  setTcAcceptedEndpoint,
  getTcAcceptedEndpoint,
} from "@/services/api/UsersService";
import Cirlces from "./img/circles.svg";
import Logo from "./img/Logo-extended.png";
import BaseButton from "../../components/Buttons/BaseButton";
import { AccountContext } from "../../services/AccountService";
import toast from "react-hot-toast";
import { Input } from "@/components/ui/input";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardDescription,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Switch } from "@/components/ui/switch";

function Login({ isMobile }) {
  const navigate = useNavigate();
  const { login } = useContext(AccountContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatedPassword, setRepeatedPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [firstLogin, setFirstLogin] = useState(false);
  const [tcAccepted, setTcAccepted] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const handleAcceptTC = async () => {
    setTcAccepted(!tcAccepted);
  };

  const handleLogin = () => {
    if (!tcAccepted) {
      toast.error("You must accept the terms and conditions.");
      return;
    }
    login(email, password)
      .then((res) => {
        if (res.data.first_login) {
          setFirstLogin(true);
          setOldPassword(password);
        } else if (!res.data.firt_login) {
          setTcAcceptedEndpoint();
          navigate("/");
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Email or password not valid.");
      });
  };

  const validateNewPassword = () => {
    // At least 8 characters, one lowercase, one uppercase, one digit, one special character (best practice)
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?`~])[A-Za-z\d!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?`~]{8,}$/;
    if (strongPasswordRegex.test(password)) {
      if (password === repeatedPassword) {
        return true;
      } else {
        toast.error("Passwords don't match");
      }
    } else {
      toast.error("Passwords don't matcth the criteria");
    }
  };

  const handleChangePassword = async () => {
    const isValid = validateNewPassword();
    if (isValid) {
      const res = await AuthService.put("/change-password", {
        email: email,
        old_password: oldPassword,
        new_password: password,
      });

      if (res.status === 200) {
        toast.success("Password changed successfully");
        handleLogin();
      }
    }
  };

  const handleForgotPassword = async () => {
    if (email === "") {
      toast.error("Insert your email address");
      return;
    }

    const res = await forgotPassword(email).catch((e) => console.log(e));

    if (res) {
      toast.success(
        "An email with a temporary password has been sent to your email address."
      );
    } else {
      toast.error("Something went wrong...");
    }
  };

  return (
    <>
      <div className="bg-base h-screen grid grid-cols-5 overflow-hidden">
        <div className="bg-base col-span-2 relative flex justify-center items-center overflow-hidden">
          <img
            src={Cirlces}
            alt="circle"
            className="absolute object-cover min-h-full min-w-full"
          />
          <img src={Logo} alt="logo" className="max-h-20 w-auto px-5" />
        </div>
        <div className="flex justify-center items-center text-gray col-span-3 flex-col bg-white">
          {/* form */}
          <div className="w-2/4">
            {firstLogin ? (
              <>
                <h2 className="font-bold text-5xl mb-5 w-full">
                  Set new password<span className="text-primary">.</span>
                </h2>

                <div className="flex items-center space-x-2 mb-2">
                  <Switch
                    id="show-password"
                    checked={showPassword}
                    onCheckedChange={() => setShowPassword(!showPassword)}
                  />
                  <Label htmlFor="show-password" className="text-xs">
                    Show Password
                  </Label>
                </div>

                <div className="mb-3">
                  <input
                    type="password"
                    className="p-3 w-full rounded border border-gray/20 outline-1"
                    placeholder="New password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {showPassword ? (
                    <span className="text-xs opacity-50">{password}</span>
                  ) : null}
                </div>
                <div>
                  <input
                    type="password"
                    className="p-3 w-full rounded border border-gray/20 outline-1"
                    placeholder="Repeat password"
                    value={repeatedPassword}
                    onChange={(e) => setRepeatedPassword(e.target.value)}
                  />
                  {showPassword ? (
                    <span className="text-xs opacity-50">
                      {repeatedPassword}
                    </span>
                  ) : null}
                </div>
                <div className="mt-5 text-xs text-primary">
                  <span>Password should match the following criteria:</span>
                  <ul className="mt-2">
                    <li>At least 8 characters in total.</li>
                    <li>At least one lowercase letter.</li>
                    <li>At least one uppercase letter.</li>
                    <li>At least one digit.</li>
                    <li>At least one special character.</li>
                  </ul>
                </div>

                <div className="flex flex-col md:flex-row mb-5 mt-5 items-center justify-between">
                  <BaseButton value="Change" onClick={handleChangePassword} />
                </div>
              </>
            ) : (
              <>
                <h2 className="font-bold text-5xl mb-5">
                  Login<span className="text-primary">.</span>
                </h2>
                <input
                  type="text"
                  className="p-3 w-full rounded border border-gray/20 mb-5 outline-1"
                  placeholder="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="password"
                  className="p-3 w-full rounded border border-gray/20 outline-1"
                  placeholder="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className="flex flex-col md:flex-row mb-5 mt-5 items-center justify-between">
                  <div
                    className="text-gray/50 hover:text-gray text-xs mb-5 md:mb-0 cursor-pointer"
                    onClick={handleForgotPassword}
                  >
                    Forgot password?
                  </div>
                  <BaseButton value="Sign In" onClick={handleLogin} />
                </div>

                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="terms"
                    checked={tcAccepted}
                    onCheckedChange={handleAcceptTC}
                  />
                  <label
                    htmlFor="terms"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    Accept{" "}
                    <a
                      className="underline"
                      href="https://www.bidcompany.it/termsconditions_chatto"
                    >
                      terms and conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.bidcompany.it/termsconditions_trialchatto2025"
                      className="underline"
                    >
                      trial license conditions
                    </a>
                  </label>
                </div>
              </>
            )}
          </div>
          {/* end - form */}
        </div>
      </div>
    </>
  );
}

export default Login;
